<template>
  <div class="d-flex-100 variationsBlock variationTextSelectorWrapper"
       v-if="variationGroupHandler().length > 1">
    <span class="attr-title" v-html="`${variationGroup.variationGroupName}`"></span>
    <div class="toggleAttrsBlkVariations" :class="{ 'overflow-y-scroll': shouldAddOverflowClass }">
      <div class="toggleAttrRadio">
        <label v-for="variationEntry in variationGroupHandler()"
             :key="variationEntry.variationId"
             :class="getVariationTextClass(defaultValue, variationEntry)">
        <input type="radio"
               :value="variationEntry.variationName"
               v-model="defaultValue"
               v-on:change="navigateToProduct(variationEntry.variationId)"
               :disabled="getVariationOutOfStock(variationEntry)">
          <span class="var-title">{{ variationEntry.variationName }}</span>
        <span v-if="variationEntry.variationDisplayValue > 0 && getSelectedCurrencySymbol" class="variation-price">
          <span v-html="`${variationEntry.variationDisplayValue} ${getSelectedCurrencySymbol()}`"></span>
        </span>
      </label>
      </div>
    </div>
  </div>
</template>

<script>
import variationSelectorMixin from './VariationSelectorMixin'

export default {
  name: 'VariationTextSelector',
  mixins: [variationSelectorMixin],
  data () {
    return {
      version: '0.0.2',
      visible: false,
      sortedVariationEntries: []
    }
  },
  created () {
    window.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.visible = false
      }
    })
    this.sortVariationEntries()
  },
  methods: {
    getVariationOutOfStock (variation) {
      return variation.stock <= 0 || variation.alreadyExists === false
    },
    getVariationTextClass (defaultValue, variation) {
      if (defaultValue === variation.variationName) {
        return 'selected'
      } else if (this.getVariationOutOfStock(variation)) {
        return 'disabled'
      }
      return ''
    },
    getSelectedCurrencySymbol () {
      return this.$store.getters.getSelectedCurrency.symbol
    },
    sortVariationEntries () {
      this.sortedVariationEntries = this.getVariationEntriesOfThisGroupFromVariationGroupData.map(variation => {
        const parsedValue = isNaN(parseFloat(variation.variationName)) ? variation.variationName : parseFloat(variation.variationName)
        return { original: variation, parsed: parsedValue }
      }).sort((a, b) => {
        if (typeof a.parsed === 'number' && typeof b.parsed === 'number') {
          return a.parsed - b.parsed
        } else {
          return a.parsed.localeCompare(b.parsed)
        }
      }).map(item => item.original)
    },
    shouldShowUniqueValuesFromVariationGroupAsDisabled () {
      return this.variationGroup.variationGroupId === 4
    },
    variationGroupHandler () {
      if (this.shouldShowUniqueValuesFromVariationGroupAsDisabled()) {
        return this.getVariationUniqueVariationValuesOfThisGroupFromVariationGroupData
      } else {
        return this.sortedVariationEntries
      }
    }
  },
  computed: {
    shouldAddOverflowClass() {
      return this.getVariationEntriesOfThisGroupFromVariationGroupData.length > 4;
    }
  }
}
</script>

<style lang="scss" scoped>
.selected { font-weight: bold }
li { cursor: pointer }

.variationTextSelectorWrapper {
  .attr-title {
    font-size: clamp(10px, 14px, 16px);
    font-weight: 800;
  }
  ::-webkit-scrollbar-thumb {
    background: yellow;
    border-radius: 10px;
  }
  .overflow-y-scroll {
    height: 128px;
    overflow: hidden;
    position: relative;

    label {
      padding: 0 5px 0 0;
    }
  }
}

.disable {
  background: #adadad;
}

.toggleAttrsBlkVariations {
  position: relative;
  width: 100%;
  display:flex;
  flex-wrap:wrap;
  input {
    height: 100%
  }
  .var-title, .variation-not-available{
    flex:0 0 100%;
    min-width:48px;
    max-width:100%;
    padding:5px;
    color: var(--prime1);
    text-align: center
  }
  .variation-not-available{
    font-size:12px;
    line-height:1.3;
    color: var(--prime1)
  }
  // label {
  //   display: flex;
  //   flex-wrap:wrap;
  //   grid-template-columns: 25px auto 3rem;
  //   grid-gap: 5px;
  //   align-items: center;
  //   text-overflow: ellipsis;
  //   overflow: hidden;
  //   white-space: nowrap;
  //   font-size:14px;
  //   font-weight:300;
  //   justify-content: flex-start;
  //   width: 100%;
  // }

  // input[type='radio'] {
  //   accent-color: #ffffff;
  //   background-color: #232323;
  // }
}

.toggleAttrRadio{
  display:flex;
  flex-wrap:wrap;
  width:100%;
  gap:15px;
  label{
    flex:0 0 fit-content;
    min-width:fit-content;
    max-width: fit-content;
    height:48px;
    display:flex;
    flex-wrap:wrap;
    justify-content: center;
    align-content:center;
    align-items:center;
    position: relative;
    border-radius:5px;
    background-color: #F2F2F2;
    border:1px solid #979797;
    transition: all 300ms ease-in-out;
    cursor: pointer;
    input[type="radio"]{
      opacity: 0;
      position: absolute;
      z-index: -1;
      width:48px;
      height:48px
    }
    &:hover,
    &.selected{
      background-color: var(--prime2);
      border-color: transparent;
    }
    &.selected{
      transform: scale(1.2);
      span{
        transform:scale(.9)
      }
    }
  }
}

.toggleAttrRadio label.disabled {
  background: #979797;
  &:hover {
    background-color: #818181;
  }
}
</style>
